import {FeatureAppDefinition, FeatureServices} from '@feature-hub/core';
import {ReactFeatureApp} from '@feature-hub/react';
import React from 'react';
import {App} from './app';
import {FeatureServicesContext} from './use-feature-services';
import dependencies from './dependencies.json';
import {HistoryServiceV3} from '@feature-hub/history-service';
import {ApiKeyProviderV1} from '@volkswagen-onehub/api-key-provider';
import {DisclaimerManagerV1} from '@volkswagen-onehub/disclaimer-manager';
import {FaContentServiceV1} from '@volkswagen-onehub/fa-content-service';
import {LayerManagerV24} from '@volkswagen-onehub/layer-manager';
import {LocaleServiceV1} from '@volkswagen-onehub/locale-service';
import {PageInfoServiceV1} from '@volkswagen-onehub/page-info-service';
import {BreadcrumbServiceV1} from '@volkswagen-onehub/breadcrumb-service';
import {ThemeProvider} from '@volkswagen-onehub/components-core';
import {CommonFeatureAppConfig} from '@volkswagen-onehub/vw-starter-feature-app-support';
import {ServiceConfigEndpointProvider} from '@volkswagen-onehub/service-config-endpoint-provider';
import {CustomThemeProvider} from './context/custom-theme-context';

export interface IdpoloMirrorFeatureAppDependencies extends FeatureServices {
  readonly 'api-key-provider'?: ApiKeyProviderV1;
  readonly 'disclaimer-manager': DisclaimerManagerV1;
  readonly 'fa-content-service'?: FaContentServiceV1;
  readonly 'layer-manager': LayerManagerV24;
  readonly 'locale-service': LocaleServiceV1;
  readonly 's2:history': HistoryServiceV3;
  readonly 'service-config-endpoint-provider': ServiceConfigEndpointProvider;
  readonly 'page-info-service': PageInfoServiceV1;
  readonly 'breadcrumb-service': BreadcrumbServiceV1;
}

export const featureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  IdpoloMirrorFeatureAppDependencies,
  CommonFeatureAppConfig
> = {
  ...dependencies,

  create: (env) => {
    const {config, featureServices} = env;

    // Keep config for future use
    console.log('Feature App config:', config);

    const {'fa-content-service': contentService} = featureServices;

    const featureAppContent = contentService?.content;

    return {
      // eslint-disable-next-line react/display-name
      render: () => (
        <FeatureServicesContext.Provider value={featureServices}>
          <CustomThemeProvider>
            <ThemeProvider theme="main">
              <App content={featureAppContent} />
            </ThemeProvider>
          </CustomThemeProvider>
        </FeatureServicesContext.Provider>
      ),
    };
  },
};

export default featureAppDefinition;
